import type { BackgroundMediaController } from "../hooks/useBackgroundMedia";
import { projects, siteConfig } from "../config/site";
import { SoundControl } from "./SoundControl";

type SiteHeaderProps = {
  readonly media: BackgroundMediaController;
};

export function SiteHeader({ media }: SiteHeaderProps) {
  return (
    <header className="absolute inset-x-0 top-0 z-30 mx-auto flex w-full max-w-[1600px] flex-wrap items-center justify-between gap-x-6 gap-y-3 border-b border-ink/15 px-[clamp(22px,4.4vw,72px)] py-7 max-[620px]:py-5">
      <a
        className="flex items-center gap-3 text-sm font-semibold tracking-[-.02em] no-underline"
        href="/"
        aria-label={`${siteConfig.domain} home`}
      >
        <img
          className="size-[30px]"
          src="/icons/favicon-32x32.png"
          srcSet="/icons/favicon-32x32.png 32w, /icons/android-chrome-192x192.png 192w"
          sizes="30px"
          alt=""
          width="30"
          height="30"
        />
        <span>{siteConfig.name}</span>
      </a>

      <nav
        aria-label="On this page"
        className="ml-auto flex items-center gap-6 font-mono text-xs max-[620px]:order-3 max-[620px]:w-full max-[620px]:gap-5"
      >
        <a
          href="#work"
          className="inline-flex min-h-11 items-center text-ink/75 hover:text-accent"
        >
          {siteConfig.work.heading}
        </a>
        {projects.length > 0 && (
          <a
            href="#sites"
            className="inline-flex min-h-11 items-center text-ink/75 hover:text-accent"
          >
            {siteConfig.projects.heading}
          </a>
        )}
      </nav>
      <div className="flex items-center" data-media-controls>
        <SoundControl media={media} />
      </div>
    </header>
  );
}
